module.exports = __webpack_public_path__ + "static/media/1.5cf0de15.jpg";